module.exports = __webpack_public_path__ + "img/robotCicadaMA.b005ba74.png";